import styled from 'styled-components';

export const StyledSeparator = styled.div<{ marginTop: string; marginBottom: string }>`
    height: 1px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey.medium};
    margin-top: ${(props) => props.marginTop};
    margin-bottom: ${(props) => props.marginBottom};
`;
